import React, { createContext, useState } from "react";
import { EditorState } from "draft-js";

const ProdutoContext = createContext();

const ProdutoContextProvider = ({ children }) => {
  //Principal
  const [productBackup, setProductBackup] = useState(null);
  const [mainProductCloning, setMainProductCloning] = useState(false);
  const [mainProductId, setMainProductId] = useState(null);
  const [mainPhotos, setMainPhotos] = useState([]);
  const [mainActive, setMainActive] = useState(true);
  const [mainDescription, setMainDescription] = useState("");
  const [mainManufacturer, setMainManufacturer] = useState(null);
  const [mainBarCode, setMainBarCode] = useState("");
  const [mainResume, setMainResume] = useState("");
  const [mainType, setMainType] = useState({
    label: "Revenda",
    id: "R",
  });
  const [mainDepartment, setMainDepartment] = useState(null);
  const [mainSector, setMainSector] = useState(null);
  const [mainGroup, setMainGroup] = useState(null);
  const [mainSubgroup, setMainSubgroup] = useState(null);
  const [mainIcmsEcf, setMainIcmsEcf] = useState("");
  const [mainNcm, setMainNcm] = useState(null);
  const [mainCest, setMainCest] = useState("");
  const [mainGtin, setMainGtin] = useState("");
  const [mainTaxGtin, setMainTaxGtin] = useState("");
  const [mainStockUnit, setMainStockUnit] = useState(null);
  const [mainSalesUnit, setMainSalesUnit] = useState(null);
  const [mainTaxUnit, setMainTaxUnit] = useState(null);
  const [mainDeliveryUnit, setMainDeliveryUnit] = useState(null);
  const [mainCodeAnp, setMainCodeAnp] = useState("");

  const [mainGrossCost, setMainGrossCost] = useState("0,00");
  const [mainRealCost, setMainRealCost] = useState("0,00");
  const [mainSalesMargin, setMainSalesMargin] = useState("0,00");
  const [mainSalePrice, setMainSalePrice] = useState("0,00");
  const [mainTaxPrice, setMainTaxPrice] = useState("0,00");
  const [mainConversionFactor, setMainConversionFactor] = useState("1,00000");
  const [taxConversionFactor, setTaxConversionFactor] = useState("1,00000");

  const [mainUseBalance, setMainUseBalance] = useState(false);

  //Custos e Preços
  const [mainFreightValue, setMainFreightValue] = useState("0,00000");
  const [mainFreightPercentage, setMainFreightPercentage] = useState("0,00000");
  const [mainWholesaleValue, setMainWholesaleValue] = useState("0,00000");
  const [mainInsuranceValue, setMainInsuranceValue] = useState("0,00000");
  const [mainInsurancePercentage, setMainInsurancePercentage] =
    useState("0,00000");
  const [mainDiscountValue, setMainDiscountValue] = useState("0,00000");
  const [mainDiscountPercentage, setMainDiscountPercentage] =
    useState("0,00000");
  const [mainOthersValue, setMainOthersValue] = useState("0,00000");
  const [mainOthersPercentage, setMainOthersPercentage] = useState("0,00000");
  const [mainIcmsStValue, setMainIcmsStValue] = useState("0,00000");
  const [mainIcmsStPercentage, setMainIcmsStPercentage] = useState("0,00000");
  const [mainIpiValue, setMainIpiValue] = useState("0,00000");
  const [mainIpiPercentage, setMainIpiPercentage] = useState("0,00000");
  const [mainPisValue, setMainPisValue] = useState("0,00000");
  const [mainPisPercentage, setMainPisPercentage] = useState("0,00000");
  const [mainCofinsValue, setMainCofinsValue] = useState("0,00000");
  const [mainCofinsPercentage, setMainCofinsPercentage] = useState("0,00000");
  const [fixedPrice, setFixedPrice] = useState(false);

  //Códigos de Barras Adicionais
  const [barCodeAdditional, setBarCodeAdditional] = useState([]);

  //Códigos de Barras Adicionais Modal
  const [barCodeAdditionalModal, setBarCodeAdditionalModal] = useState([]);

  //Locais de estoque
  const [stockLocations, setStockLocations] = useState([]);

  //Tablea Preco
  const [priceTable, setPriceTable] = useState([]);

  //Fornecedores
  const [supplier, setSupplier] = useState(null);
  const [supplierRef, setSupplierRef] = useState("");
  const [supplierPurchaseUnit, setSupplierPurchaseUnit] = useState(null);
  const [supplierDescription, setSupplierDescription] = useState("");
  const [supplierConversionFactor, setSupplierConversionFactor] =
    useState("1,00");
  const [supplierOthers, setSupplierOthers] = useState([]);

  //Ficha Técnica/Comercial/Combustivel
  const [datasheetWeight, setDatasheetWeight] = useState("0,000");
  const [datasheetCubage, setDatasheetCubage] = useState("0,000");
  const [datasheetQtdPackaging, setDatasheetQtdPackaging] = useState("0,00");
  const [datasheetWidth, setDatasheetWidth] = useState("0,000");
  const [datasheetHeight, setDatasheetHeight] = useState("0,000");
  const [datasheetLength, setDatasheetLength] = useState("0,000");
  const [datasheetDepth, setDatasheetDepth] = useState("0,000");
  const [datasheetAnvisa, setDatasheetAnvisa] = useState("");
  const [datasheetGeneric, setDatasheetGeneric] = useState(false);
  const [datasheetObservation, setDatasheetObservation] = useState("");
  const [datasheetBlockNf, setDatasheetBlockNf] = useState(false);
  const [datasheetBlockCf, setDatasheetBlockCf] = useState(false);
  const [datasheetPublishedPrice, setDatasheetPublishedPrice] = useState(false);
  const [datasheetTrackPrice, setDatasheetTrackPrice] = useState(false);
  const [datasheetCommercialPartner, setDatasheetCommercialPartner] =
    useState(null);
  const [datasheetCommercialPercent, setDatasheetCommercialPercent] =
    useState("0,00");
  const [datasheetLastSale, setDatasheetLastSale] = useState("");
  const [datasheetLastPurchase, setDatasheetLastPurchase] = useState("");
  const [datasheetLastBudget, setDatasheetLastBudget] = useState("");
  const [dataSheetTags, setDataSheetTags] = useState([]);
  const [dataEditor, setDataEditor] = useState(EditorState.createEmpty());

  const [datasheetDescriptionANP, setDatasheetDescriptionANP] = useState("");
  const [datasheetGlpPetroleum, setDatasheetGlpPetroleum] = useState("0,0000");
  const [datasheetNationalGas, setDatasheetNationalGas] = useState("0,0000");
  const [datasheetImportedGas, setDatasheetImportedGas] = useState("0,0000");
  const [
    datasheetStartingValueWithoutICMS,
    setDatasheetStartingValueWithoutICMS,
  ] = useState("0,00000");

  //Relacionados, Similares e Transformação
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [transformationProducts, setTransformationProducts] = useState([]);

  //Integração
  const [woocomerceShowSite, setWoocomerceShowSite] = useState(false);
  const [woocomerceUpdateSite, setWoocomerceUpdateSite] = useState(false);
  const [lunetNegativeStock, setLunetNegativeStock] = useState(null);

  const [expanded, setExpanded] = useState({ general: true });
  const [listSupplier, setListSupplier] = useState([]);
  const [listNcm, setListNcm] = useState([]);
  const [listUnits, setListUnits] = useState([]);
  const [listManufacturer, setListManufacturer] = useState([]);
  const [listStockLocations, setListStockLocations] = useState([]);
  const [listSizeTypes, setListSizeTypes] = useState([]);
  const [listDepartments, setListDepartments] = useState([]);
  const [listSectors, setListSectors] = useState([]);
  const [listCommercialPartner, setListCommercialPartner] = useState([]);
  const [listGroups, setListGroups] = useState([]);
  const [listSubgroups, setListSubgroups] = useState([]);
  const [pricesList, setPricesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState({});
  const [errors, setErrors] = useState({});
  const [rowEdit, setRowEdit] = useState(null);

  return (
    <ProdutoContext.Provider
      value={{
        //Principal
        productBackup,
        setProductBackup,
        mainProductCloning,
        setMainProductCloning,
        mainProductId,
        setMainProductId,
        mainPhotos,
        setMainPhotos,
        mainActive,
        setMainActive,
        mainDescription,
        setMainDescription,
        mainManufacturer,
        setMainManufacturer,
        mainBarCode,
        setMainBarCode,
        mainResume,
        setMainResume,
        mainType,
        setMainType,
        mainDepartment,
        setMainDepartment,
        mainSector,
        setMainSector,
        mainGroup,
        setMainGroup,
        mainSubgroup,
        setMainSubgroup,
        mainIcmsEcf,
        setMainIcmsEcf,
        mainNcm,
        setMainNcm,
        mainCest,
        setMainCest,
        mainGtin,
        setMainGtin,
        mainTaxGtin,
        setMainTaxGtin,
        mainStockUnit,
        setMainStockUnit,
        mainSalesUnit,
        setMainSalesUnit,
        mainTaxUnit,
        setMainTaxUnit,
        mainDeliveryUnit,
        setMainDeliveryUnit,
        mainCodeAnp,
        setMainCodeAnp,
        mainGrossCost,
        setMainGrossCost,
        mainRealCost,
        setMainRealCost,
        mainSalesMargin,
        setMainSalesMargin,
        mainSalePrice,
        setMainSalePrice,
        mainTaxPrice,
        setMainTaxPrice,
        mainConversionFactor,
        setMainConversionFactor,
        taxConversionFactor,
        setTaxConversionFactor,
        mainUseBalance,
        setMainUseBalance,

        //Custos e Preços
        mainFreightValue,
        setMainFreightValue,
        mainFreightPercentage,
        setMainFreightPercentage,
        mainInsuranceValue,
        setMainInsuranceValue,
        mainInsurancePercentage,
        setMainInsurancePercentage,
        mainDiscountValue,
        setMainDiscountValue,
        mainDiscountPercentage,
        setMainDiscountPercentage,
        mainOthersValue,
        setMainOthersValue,
        mainOthersPercentage,
        setMainOthersPercentage,
        mainIcmsStValue,
        setMainIcmsStValue,
        mainIcmsStPercentage,
        setMainIcmsStPercentage,
        mainIpiValue,
        setMainIpiValue,
        mainIpiPercentage,
        setMainIpiPercentage,
        mainPisValue,
        setMainPisValue,
        mainPisPercentage,
        setMainPisPercentage,
        mainCofinsValue,
        setMainCofinsValue,
        mainCofinsPercentage,
        setMainCofinsPercentage,
        mainWholesaleValue,
        setMainWholesaleValue,
        fixedPrice,
        setFixedPrice,

        //Códigos de Barras Adicionais
        barCodeAdditional,
        setBarCodeAdditional,

        //Locais de estoque
        stockLocations,
        setStockLocations,

        //Tabela Precos
        priceTable,
        setPriceTable,
        pricesList,
        setPricesList,

        //Fornecedore
        supplier,
        setSupplier,
        supplierRef,
        setSupplierRef,
        supplierPurchaseUnit,
        setSupplierPurchaseUnit,
        supplierDescription,
        setSupplierDescription,
        supplierConversionFactor,
        setSupplierConversionFactor,
        supplierOthers,
        setSupplierOthers,

        //Ficha Técnica/Comercial/Combustivel
        datasheetWeight,
        setDatasheetWeight,
        datasheetCubage,
        setDatasheetCubage,
        datasheetQtdPackaging,
        setDatasheetQtdPackaging,
        datasheetWidth,
        setDatasheetWidth,
        datasheetHeight,
        setDatasheetHeight,
        datasheetLength,
        setDatasheetLength,
        datasheetAnvisa,
        setDatasheetAnvisa,
        datasheetGeneric,
        setDatasheetGeneric,
        datasheetObservation,
        setDatasheetObservation,
        datasheetBlockNf,
        setDatasheetBlockNf,
        datasheetBlockCf,
        setDatasheetBlockCf,
        datasheetPublishedPrice,
        setDatasheetPublishedPrice,
        datasheetTrackPrice,
        setDatasheetTrackPrice,
        datasheetCommercialPartner,
        setDatasheetCommercialPartner,
        datasheetCommercialPercent,
        setDatasheetCommercialPercent,
        datasheetLastSale,
        setDatasheetLastSale,
        datasheetLastPurchase,
        setDatasheetLastPurchase,
        datasheetLastBudget,
        setDatasheetLastBudget,
        dataSheetTags,
        setDataSheetTags,
        dataEditor,
        setDataEditor,
        datasheetDepth,
        setDatasheetDepth,
        datasheetDescriptionANP,
        setDatasheetDescriptionANP,
        datasheetGlpPetroleum,
        setDatasheetGlpPetroleum,
        datasheetNationalGas,
        setDatasheetNationalGas,
        datasheetImportedGas,
        setDatasheetImportedGas,
        datasheetStartingValueWithoutICMS,
        setDatasheetStartingValueWithoutICMS,

        //Relacionados, Similares e Transformação
        relatedProducts,
        setRelatedProducts,
        similarProducts,
        setSimilarProducts,
        transformationProducts,
        setTransformationProducts,

        //Integração
        woocomerceShowSite,
        setWoocomerceShowSite,
        woocomerceUpdateSite,
        setWoocomerceUpdateSite,
        lunetNegativeStock,
        setLunetNegativeStock,

        listSupplier,
        setListSupplier,
        listNcm,
        setListNcm,
        listUnits,
        setListUnits,
        listManufacturer,
        setListManufacturer,
        listStockLocations,
        setListStockLocations,

        listSizeTypes,
        setListSizeTypes,
        listGroups,
        setListGroups,
        listSubgroups,
        setListSubgroups,
        listDepartments,
        setListDepartments,
        listSectors,
        setListSectors,
        listCommercialPartner,
        setListCommercialPartner,
        expanded,
        setExpanded,
        loadingInputs,
        setLoadingInputs,
        loading,
        setLoading,
        errors,
        setErrors,
        rowEdit,
        setRowEdit,
        barCodeAdditionalModal,
        setBarCodeAdditionalModal,
      }}
    >
      {children}
    </ProdutoContext.Provider>
  );
};

export { ProdutoContextProvider, ProdutoContext };
